import { SET_AUTH_VALUES } from '../actionTypes';
import { loginActions } from '../reducer';

export default (values) => loginActions[SET_AUTH_VALUES](values);
